import React from "react";
import { DocumentRenderer } from "components";
import PaySlipDetail from "./PaySlipDetail";
import { Trans } from "react-i18next";

export default ({
    items,
    t,
    client,
    settings: settingsProp,
    selectedOrganisation,
    ...props
}) => {
    const [settings, setSettings] = React.useState(settingsProp);

    const onMount = async () => {
        if (settings) return;

        const s = await client
            .get(`payroll/${selectedOrganisation.id}/settings/1/public`)
            .get("data");
        setSettings(s);
    };
    React.useEffect(() => void onMount(), []);

    if (!settings) return null;

    return (
        <>
            {items &&
                <DocumentRenderer {...props}>
                    <div className="container-fluid m-0 p-0">
                        <div className="header">
                            <h4 className="mb-5">
                                <Trans>All payslips of the period : {items[0].pay_run__start_date} : {items[0].pay_run__end_date}</Trans>
                            </h4>
                        </div>
                        {items.map((item) => (
                            <>
                                <div className="break-after">
                                <div className="py-5">
                                    <PaySlipDetail item={item} settings={settings} />
                                    <div className="border border-bottom w-25 border-secondary mx-auto my-5"></div>
                                </div>
                                </div>
                            </>
                        ))}
                    </div>
                </DocumentRenderer>}
        </>
    );
};
